import React from "react";

export const CourseCircleDesktopIcon = (props) => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50 1.4165C77.0697 1.4165 98.9998 23.1757 99 49.9995C99 76.8235 77.0699 98.5835 50 98.5835C22.9301 98.5835 1 76.8235 1 49.9995C1.00018 23.1757 22.9303 1.4165 50 1.4165Z"
        fill="white"
        stroke="#E4E4E4"
        strokeWidth="2"
      />
      <path
        d="M40.4902 40.5723V60.0406"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3057 47.0617V53.5511C50.3057 55.2722 50.9951 56.9228 52.2223 58.1399C53.4496 59.3569 55.1141 60.0406 56.8496 60.0406C58.5852 60.0406 60.2497 59.3569 61.4769 58.1399C62.7041 56.9228 63.3936 55.2722 63.3936 53.5511V47.0617C63.3936 45.3406 62.7041 43.69 61.4769 42.473C60.2497 41.256 58.5852 40.5723 56.8496 40.5723C55.1141 40.5723 53.4496 41.256 52.2223 42.473C50.9951 43.69 50.3057 45.3406 50.3057 47.0617Z"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8584 50.3076V50.3393"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.7539 50.3076V50.3393"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3057 79.5083V79.54"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.582 24.9966V25.0282"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.0303 75.6143V75.6459"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.582 75.6143V75.6459"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7842 64.9058V64.9374"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.8271 64.9058V64.9374"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7842 35.7007V35.7323"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.8599 35.7914C73.2837 31.3269 69.5633 27.6169 65.0757 25.0374C60.5881 22.4579 55.4927 21.1004 50.3057 21.1025"
        stroke="#18428E"
        strokeWidth="3.9218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
